import React from "react";
import { useTable } from "../../Components/useTable";

const UserReportList = () => {
  const type = "User Report";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "reason", numeric: false, label: "Reason" },
    { id: "reporterUserName", numeric: false, label: "Reporter Name" },
    { id: "reporterUserCode", numeric: false, label: "Reporter RID" },
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "respondedUserName", numeric: false, label: "Respond Name" },
    { id: "respondedUserCode", numeric: false, label: "Respond RID" },
    { id: "picture", numeric: false, label: "Image" },
    { id: "created", numeric: false, label: "Date" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default UserReportList;
